import { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { AuthUserContext } from "../../context/AuthUserContext";
import { useNavigation } from "../../utils/navigation";
import { useTranslation } from "react-i18next";

const Card = styled.figure`
  position: relative;
  background-color: var(--bg-100);
  width: 100%;
  margin: 0;
  overflow: hidden;
  box-shadow: var(--shadow-large);
  border-radius: var(--border-radius-large);
`;

const Hero = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-md);
  background-color: var(--primary-200);
  color: var(--bg-100);
  padding: var(--spacing-lg);
`;

const Eyebrow = styled.span`
  display: block;
  font-size: var(--font-size-small);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.8;
`;

const Name = styled.p`
  font-size: var(--font-size-xlarge);
  color: var(--bg-100);
  margin: var(--spacing-xxs) 0 0 0;
`;

const EditLink = styled(Link)`
  flex-shrink: 0;
  border-radius: var(--border-radius-large);
  padding: var(--spacing-xs) var(--spacing-lg);
  background-color: transparent;
  border: 1px solid var(--bg-100);
  color: var(--bg-100);
  text-transform: uppercase;
  font-size: var(--font-size-small);
  &:hover {
    background-color: var(--bg-100);
    color: var(--primary-200);
  }
`;

const Details = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1px;
  background-color: var(--bg-300);

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Tile = styled.div`
  background-color: var(--bg-100);
  padding: var(--spacing-md) var(--spacing-lg);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xxs);
`;

const Label = styled.span`
  font-size: var(--font-size-small);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-200);
`;

const Value = styled.span`
  font-size: var(--font-size-base);
  color: var(--text-100);
`;

const PersonalInfoCard = () => {
  const { t } = useTranslation();
  const { userProfile } = useContext(AuthUserContext);
  const { goToProfile } = useNavigation();

  return (
    <Card>
      <Hero>
        <div>
          <Eyebrow>{t("PROFILE.ACCOUNT_OVERVIEW")}</Eyebrow>
          <Name>
            {userProfile.first_name} {userProfile.last_name}
          </Name>
        </div>
        <EditLink to={goToProfile()}>{t("BUTTONS.EDIT")}</EditLink>
      </Hero>
      <Details>
        <Tile>
          <Label>{t("LABELS.EMAIL")}</Label>
          <Value>{userProfile.email}</Value>
        </Tile>
        <Tile>
          <Label>{t("LABELS.PHONE_NUMBER")}</Label>
          <Value>{userProfile.phone_number}</Value>
        </Tile>
      </Details>
    </Card>
  );
};

export default PersonalInfoCard;
